import * as stylex from "@stylexjs/stylex";
const MultipleHeroes = ({ datasets, Component })=><>
    <Component key="-1" renderMode="dropzone"/>
    {Object.keys(datasets).map((key)=><>
        <h2 className="x2b8uid">Dataset: {datasets[key].filename}</h2>
        <Component key={key} renderMode="embed" dataset={key}/>
      </>)}
  </>;
export default MultipleHeroes;
